import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons'

import InfoIcon from 'components/InfoIcon'

import styles from './styles.scss'

const FormField = React.forwardRef((props, ref) => {
  const {
    children,
    className,
    dataTestId,
    direction,
    hideErrorMessage,
    errorMessage,
    label,
    labelOnClick,
    labelRight,
    labelStyle,
    required,
    style,
    toolTip,
    toolTipIcon,
  } = props

  return (
    <div
      className={classnames(styles.root, required ? styles.required : null, styles[direction], className)}
      data-test-id={dataTestId}
      ref={ref}
      style={style}
    >
      {label && (
        <label className={styles.label} onClick={labelOnClick} style={labelStyle}>
          <span className={styles.left}>{label}</span>

          {toolTip && (
            <InfoIcon
              className={styles.infoIcon}
              infoClassName={styles.info}
              iconComponent={toolTipIcon || <FontAwesomeIcon icon={faInfoCircle} className={styles.icon} />}
              description={toolTip}
            />
          )}

          {!!errorMessage && !hideErrorMessage && (
            <>
              <span>&nbsp;-&nbsp;</span>
              <span className={styles.errorMessage}>{errorMessage}</span>
            </>
          )}

          <span className={styles.right}>{labelRight}</span>
        </label>
      )}

      <span
        className={classnames(
          styles.fieldHolder,
          styles[direction],
          errorMessage ? styles.error : null,
        )}
      >
        {children}
      </span>
    </div>
  )
})

FormField.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  direction: PropTypes.string,
  hideErrorMessage: PropTypes.bool,
  errorMessage: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  labelOnClick: PropTypes.func,
  labelRight: PropTypes.object,
  labelStyle: PropTypes.object,
  ref: PropTypes.object,
  required: PropTypes.bool,
  style: PropTypes.object,
  toolTip: PropTypes.string,
  toolTipIcon: PropTypes.object,
}

FormField.defaultProps = {
  direction: 'row',
}

export default FormField
